import type { TranslationMessages } from './types';

export const richTextUltra: TranslationMessages = {
  tabs: {
    richText: 'Rich Text',
    html: 'HTML',
    plainText: 'Văn bản thuần',
  },
  placeholders: {
    richText: 'Nhập nội dung Rich Text...',
    html: 'Nhập nội dung HTML...',
    plainText: 'Nhập nội dung văn bản thuần...',
  },
};
